import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpPutService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IWepodPayOrderCommand from '../../types/Commands/IWepodPayOrderCommand';

export const wepodPayOrder = createAsyncThunk('Order/wepodPayOrder', async (command: IWepodPayOrderCommand) => {
  return await OrdersHttpPutService({
    url: `${_apiPathManagerConfig?.Orders.Order.PayOrder}`,
    body: command,
  });
});
